import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home',
  styleUrls: ['./home.component.css'],
  template: `
    <ngx-loading-bar [includeSpinner]="false" [height]="'2px'" [color]="'#ffffff'"></ngx-loading-bar>
    <app-header></app-header>
    <router-outlet></router-outlet>           
    <app-footer></app-footer>
  `,
})
export class HomeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
